// Copyright 2023 Sorama B.V.
import { DialogController } from "aurelia-dialog";
import { autoinject } from "aurelia-framework";

export interface BatchOperationResultModel {
    title?: string;
    text?: string;
    results?: { name: string; message: string }[];
    closeText?: string;
    cancelText?: string;
}

@autoinject
export class BatchOperatioResultDialog {
    private allMessagesAreEqual = false;

    // The default model
    private model: BatchOperationResultModel = {
        title: "Batch Operation",
        text: "The batch operation completed with the following results:",
        results: [],
        closeText: "Ok",
    };

    constructor(private readonly controller: DialogController) {}

    public activate(batchOperationResultModel: BatchOperationResultModel) {
        // Overwrite the default properties if the property exists in the passed model
        this.model = { ...this.model, ...batchOperationResultModel };

        this.allMessagesAreEqual = this.model.results.every((r) => r.message === this.model.results[0].message);
    }

    protected close(): void {
        this.controller.cancel();
    }

    protected ok(): void {
        this.controller.ok();
    }
}
